<div class="cnt-form-enquiry">
    <!-- CUSTOMER // CUSTOMER EQNUIRY NO // OFFER STATUS-->
    <div class="row-form">
        <!-- CUSTOMER -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.CustomerName' | translate" [isMobile]="isMobile"
            [isRequired]="(action == 'create' ? true : false)" [disabled]="(action == 'create' ? false : true)" [value]="(action == 'create' ? '' : enquiryByEnquiryNo.enquiry!.customer!.customerName!)"
            [showCreate]="true" [autoComplete]="true"
            [autoCompleteDataset]="customerList"
            [autoCompleteColumns]="['customerId', 'customerName', 'customerCode', 'unitSystem',  'isDummy' ]"
            [autoCompleteColumnsToHide]="['customerId','unitSystem','customerCountry']"
            [autoCompleteField]="'customer'" [columnsWidthPerc]="[55,15,15,15]"
            (onAutocompleteLinkClick)="onAutocompleteCustomerLinkClick($event)" [isValid]="customerIsValid"
            style="width:58%" [noMinWidth]="true"
            (onAutocompleteSelect)="onAutocompleteSelectCustomer($event)" [selectable]="false"
            [multiSelection]="false"
            (onAutocompleteInputChange)="onAutocompleteCustomerInputChange($event)"
            [readOnly]="(action == 'create' ? false : true)" [tabIndex]="(action == 'create' ? 0 : 100)">
        </teiasoft-input>

        <!-- CUSTOMER EQNUIRY NO -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.CustomerEnquiryNo' | translate" [isMobile]="isMobile"
            [isRequired]="false" [disabled]="false" [value]="(action == 'create' ? '' : enquiryByEnquiryNo.enquiry!.customerEnquiryNo!)"
            style="width:18%" [noMinWidth]="true" [tabIndex]="(action == 'create' ? 1 : 0)">
        </teiasoft-input>

        <!-- OFFER STATUS -->
        <teiasoft-select [labelText]="'grid.MstOfferStatus' | translate" [isMobile]="isMobile"
            [isRequired]="(action == 'create' ? true : false)" [disabled]="(action == 'create' ? false : true)"
            [spaceLabel]="true" [noMinWidth]="true" [isValid]="offerStatusValid" [defaultValue]="enquiryByEnquiryNo.enquiry!.mstOfferStatus!"
            [optionsList]="mstOfferStatusList"
            (onSelected)="onSelectedOfferStatus($event)" style="width:18%" [tabIndex]="(action == 'create' ? 2 : 101)">
        </teiasoft-select>
    </div>
    <!-- CUSTOMER COUNTRY // CUSTOMER CODE // UOM SYSTEM // OFFER DUE DATE // OFFICE -->
    <div class="row-form">
        <!-- CUSTOMER COUNTRY -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.CustomerCountry' | translate" [isMobile]="isMobile"
            [isRequired]="false" [disabled]="false" [value]="(action == 'create' ? '' : enquiryByEnquiryNo.enquiry!.customer!.customerCountry!.countryName)"
            style="width:18%" [noMinWidth]="true" [disabled]="true">
        </teiasoft-input>

        <!-- CUSTOMER CODE -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.CustomerCode' | translate" [isMobile]="isMobile"
            [isRequired]="false" [disabled]="false" [value]="(action == 'create' ? '' : enquiryByEnquiryNo.enquiry!.customer!.customerCode!)"
            style="width:18%" [noMinWidth]="true" [disabled]="true">
        </teiasoft-input>

        <!-- UOM SYSTEM -->
        <teiasoft-select [labelText]="'grid.UnitSystem' | translate" [isMobile]="isMobile"
            [isRequired]="(action == 'create' ? true : false)" [disabled]="(action == 'create' ? false : true)"
            [spaceLabel]="true" [noMinWidth]="true" [isValid]="offerStatusValid" [defaultValue]="enquiryByEnquiryNo.enquiry!.unitSystem!"
            [optionsList]="unitSystemList" 
            (onSelected)="onSelectedUnitSystem($event)" style="width:18%" [tabIndex]="(action == 'create' ? 3 : 102)">
        </teiasoft-select>

        <!-- OFFER DUE DATE -->
        <teiasoft-datetime [value]="enquiryByEnquiryNo.enquiry!.dueDate! != null ? enquiryByEnquiryNo.enquiry!.dueDate!.toString() : ''"
            style="width:18%"
            [labelText]="'grid.DueDate' | translate" [type]="'date'" [isRequired]="false"
            [disabled]="false" [isMobile]="isMobile" [isValid]="dueDateValid" [dateFormat]="globals!.dateFormat!"
            (onChange)="onChangeDueDate($event)" [tabIndex]="(action == 'create' ? 3 : 1)">
        </teiasoft-datetime>

        <!-- OFFICE -->
        <teiasoft-select [labelText]="'grid.SalesOffice' | translate" [isMobile]="isMobile"
            [isRequired]="(action == 'create' ? true : false)" [disabled]="(action == 'create' ? false : true)"
            [spaceLabel]="true" [noMinWidth]="true" [defaultValue]="getSalesOfficeValue(enquiryByEnquiryNo.enquiry!.salesOffice!)"
            [optionsList]="salesOfficeList"
            (onSelected)="onSelectedSalesOffice($event)" style="width:18%" [tabIndex]="(action == 'create' ? 4 : 103)">
        </teiasoft-select>
    </div>
    <!-- PROJECT NAME // SMS // ALLOY SURCHARGE // ORDER REASON // MARKET FAMILY -->
    <div class="row-form">
        <!-- PROJECT NAME -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.projectName' | translate" [isMobile]="isMobile"
            [isRequired]="false" [disabled]="false" [value]="(action == 'create' ? '' : enquiryByEnquiryNo.enquiry!.projectName!)"
            style="width:18%" [noMinWidth]="true" [tabIndex]="(action == 'create' ? 5 : 0)">
        </teiasoft-input>

        <!-- SMS -->
        <teiasoft-select [labelText]="'grid.Sms' | translate" [isMobile]="isMobile"
            [isRequired]="true" 
            [spaceLabel]="true" [noMinWidth]="true" [isValid]="smsValid" [defaultValue]="getSmsValue(enquiryByEnquiryNo.enquiry!.sms!.name!)"
            [optionsList]="smsList" 
            (onSelected)="onSelectedSms($event)" style="width:18%" [tabIndex]="(action == 'create' ? 6 : 102)">
        </teiasoft-select>

        <!-- SMS -->
        <teiasoft-select [labelText]="'grid.AlloySurcharge' | translate" [isMobile]="isMobile"
            [isRequired]="true" 
            [spaceLabel]="true" [noMinWidth]="true" [isValid]="alloySurchargeValid" [defaultValue]="enquiryByEnquiryNo.enquiry!.alloySurcharge!"
            [optionsList]="alloySurchargeList" 
            (onSelected)="onSelectedAlloySurcharge($event)" style="width:18%" [tabIndex]="(action == 'create' ? 7 : 102)">
        </teiasoft-select>

        <!-- ORDER REASON -->
        <teiasoft-select [labelText]="'grid.OrderReason' | translate" [isMobile]="isMobile"
            [isRequired]="false" 
            [spaceLabel]="true" [noMinWidth]="true" [defaultValue]="enquiryByEnquiryNo.enquiry!.orderReason!"
            [optionsList]="orderReasonList" 
            (onSelected)="onSelectedOrderReason($event)" style="width:18%" [tabIndex]="(action == 'create' ? 7 : 102)">
        </teiasoft-select>

        <!-- MARKET FAMILY -->
        <teiasoft-select [labelText]="'grid.MarketFamily' | translate" [isMobile]="isMobile"
            [isRequired]="false" [isRequired]="true"
            [spaceLabel]="true" [noMinWidth]="true" [defaultValue]="enquiryByEnquiryNo.enquiry!.marketFamily!.marketFamilyId"
            [optionsList]="marketFamilyList" [isValid]="marketFamilyValid"
            (onSelected)="onSelectedOrderReason($event)" style="width:18%" [tabIndex]="(action == 'create' ? 7 : 102)">
        </teiasoft-select>
    </div>
    <!-- APPLICABLE NORMS // NORMGARDES // RAW MATERIAL GRADE -->
    <div class="row-form">
        <!-- PROJECT NAME -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.ApplicableNorms' | translate" [isMobile]="isMobile"
            [isRequired]="false" [disabled]="false" [value]="(action == 'create' ? '' : enquiryByEnquiryNo.enquiry!.applicableNorms)"
            style="width:18%" [noMinWidth]="true" [tabIndex]="(action == 'create' ? 5 : 0)">
        </teiasoft-input>
        
        <!-- NORM GRADES -->
        <teiasoft-input [type]="'text'"
            [labelText]="'grid.NormGrades' | translate" [isMobile]="isMobile"
            [isRequired]="true" [disabled]="false" [value]="(action == 'create' ? '' : getNormGrades())"
            [showCreate]="false" [autoComplete]="true" [multiSelection]="true" [selectable]="true"
            [autoCompleteDataset]="normGradesDataSet"
            [autoCompleteColumns]="['normGradeCode']"
            [autoCompleteColumnsToHide]="['normGradeId']"
            [autoCompleteField]="'normGrades'" [columnsWidthPerc]="[100]"
            [isValid]="normGradesValid"
            style="width:58%" [noMinWidth]="true"
            (onAutocompleteSelect)="onAutocompleteSelectNormGrade($event)" [selectable]="false"
            (onAutocompleteInputChange)="onAutocompleteNormGradeInputChange($event)"
            [readOnly]="false" [tabIndex]="(action == 'create' ? 0 : 100)">
        </teiasoft-input>

        <!-- RAW MATERIAL GRADE -->
        <teiasoft-select [labelText]="'grid.RawMaterialGrade' | translate" [isMobile]="isMobile"
            [isRequired]="false" 
            [spaceLabel]="true" [noMinWidth]="true" [defaultValue]="enquiryByEnquiryNo.enquiry!.rawMaterialGrade!"
            [optionsList]="rawMaterialGradeList" 
            (onSelected)="onSelectedRawMaterial($event)" style="width:18%" [tabIndex]="(action == 'create' ? 7 : 102)">
        </teiasoft-select>
    </div>
</div>
